import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, from, of } from 'rxjs';

import { map } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth/auth.service';
import { DropdownService } from 'src/app/services/dropdown/dropdown.service';
import { LoginResponseData } from 'src/app/interfaces/LoginResponseData';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
    private dropService: DropdownService,
  ) { }

  async canActivate(
    route: ActivatedRouteSnapshot,
    router: RouterStateSnapshot,
  ): Promise<boolean | UrlTree> {
    console.log('🛡️ AUTH GUARD DEBUG: Checking access for route:', route.routeConfig?.path);
    console.log('🛡️ AUTH GUARD DEBUG: Current URL:', router.url);

    let statusResponse: Observable<LoginResponseData> =
      await this.authService.checkStatus();
    let returnValue: Promise<boolean | UrlTree> = statusResponse
      .pipe(
        map((res: LoginResponseData) => {
          console.log('🛡️ AUTH GUARD DEBUG: Status check response:', res);

          if (res.status == 1) {
            console.log('🛡️ AUTH GUARD DEBUG: ✅ User authenticated (status 1), allowing access');
            return true;
          } else if (res.status == 0) {
            console.log('🛡️ AUTH GUARD DEBUG: ❌ User not authenticated (status 0), redirecting to login');
            this.dropService.closeSidebar();
            // return this.router.createUrlTree(['/survey/0']);
            return this.router.createUrlTree(['/']);
          } else if (res.status == 2) {
            console.log('🛡️ AUTH GUARD DEBUG: 🔄 User needs password change (status 2), redirecting');
            return this.router.createUrlTree(['requirepasswordchange']);
          } else {
            console.log('🛡️ AUTH GUARD DEBUG: ❓ Unknown status:', res.status, 'denying access');
            return false;
          }
        }),
      )
      .toPromise() as Promise<boolean | UrlTree>;

    return returnValue;
  }
}
